import type { LocationMeasurement, TemperatureMeasurement } from 'graphql-models';
import { randomId, type Factory } from './helpers';

const MOCK_TEMPERATURE_MEASUREMENTS: TemperatureMeasurement = {
  id: '1',
  measuredAt: new Date().toISOString(),
  valueCelsius: 20,
};

const MOCK_LOCATION_MEASUREMENTS: LocationMeasurement = {
  id: '1',
  measuredAt: new Date().toISOString(),
  latitude: 0,
  longitude: 0,
};

export const temperatureMeasurementFactory: Factory<TemperatureMeasurement> = (overrides) => ({
  ...MOCK_TEMPERATURE_MEASUREMENTS,
  id: randomId(),
  ...overrides,
});

export const locationMeasurementFactory: Factory<LocationMeasurement> = (overrides) => ({
  ...MOCK_LOCATION_MEASUREMENTS,
  id: randomId(),
  ...overrides,
});
